import { render, staticRenderFns } from "./AddonDeletionConfirmModal.vue?vue&type=template&id=35088461&scoped=true&lang=pug&"
import script from "./AddonDeletionConfirmModal.vue?vue&type=script&lang=js&"
export * from "./AddonDeletionConfirmModal.vue?vue&type=script&lang=js&"
import style0 from "./AddonDeletionConfirmModal.vue?vue&type=style&index=0&id=35088461&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35088461",
  null
  
)

export default component.exports